import { render, staticRenderFns } from "./ArticlesSearch.vue?vue&type=template&id=15d70708"
import script from "./ArticlesSearch.vue?vue&type=script&lang=js"
export * from "./ArticlesSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports